module.exports = __webpack_public_path__ + "static/img/产品中心-液压支架辅助安装机器人-降本增效提安.e798ea04.png";